export enum SubscribeDomainsUploadMode {
    Replace = "replace",
    Append = "append",
}

export enum SubscribeDomainsUploadModeId {
    Replace = "replace-domains-action",
    Append = "append-domains-action",
}
